import React from "react";
import { Box, Typography, Button } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

const Unauthorized = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      bgcolor="#f7f7f7"
      textAlign="center"
      px={3}
    >
      <LockIcon sx={{ fontSize: 80, color: "#887952", mb: 2 }} />
      <Typography variant="h4" fontWeight="bold">
        403 - Forbidden
      </Typography>
      <Typography variant="body1" color="textSecondary" mt={1} mb={3}>
        You don’t have permission to access this page.
      </Typography>
      <Button
        variant="contained"
        sx={{
          backgroundColor: "#887952",
          "&:hover": { backgroundColor: "#746542" },
          color: "#fff",
          fontWeight: "bold",
          px: 3,
          py: 1,
          borderRadius: "8px",
        }}
        onClick={() => (window.location.href = "/")}
      >
        Go to Homepage
      </Button>
    </Box>
  );
};

export default Unauthorized;
